import styles from "../styles/Header_temp.module.scss";
import person from "../../../assets/images/person.png";

var profileimage =
  "https://raw.githubusercontent.com/AbdulSamadgithub/AbdulSamadgithub/df23f5bff838b77ff50b069274787f1e4a9455a0/profile_Compressed-removebg-preview.png";

function Header(props) {
  return (
    <div className={styles.maincontainer}>
      <RightContainer />
      <LeftContainer />
    </div>
  );
}

function RightContainer() {
  return (
    <div className={styles.rightcontainer}>
      <div className={styles.eclipse}>
        <img alt="" className={styles.image} src={profileimage}></img>
      </div>
    </div>
  );
}

function LeftContainer() {
  return (
    <div className={styles.leftcontainer}>
      <div className={styles.description}>
        Hi. I’m ABDUL SAMAD, UI UX designer, full stack mobile and website
        developer. I help individuals and startups in accomplishing their goals
        by
      </div>
      <div className={styles.title}>Creating best systems and designs</div>
      <div className={styles.separator}></div>

      {/* buttons row */}
      <div className={styles.buttonsrow}>
        <button className={styles.button}>Lets Talk</button>
        <button className={styles.textbutton}>See Portfolio</button>
      </div>
      {/* buttons row */}
      {/* social media buttons container */}
      <div className={styles.socialcontainer}>
        <div className={styles.socialbutton}>
          <img
            alt="social"
            src="https://img.icons8.com/color/344/facebook-new.png"
            className={styles.socialbutton}
          ></img>
        </div>
        <div className={styles.socialbutton}>
          <img
            alt="social"
            src="https://img.icons8.com/color/344/linkedin-circled--v1.png"
            className={styles.socialbutton}
          ></img>
        </div>
        <div className={styles.socialbutton}>
          <img
            alt="social"
            src="https://img.icons8.com/plasticine/344/whatsapp.png"
            className={styles.socialbutton}
          ></img>
        </div>
      </div>
      {/* social media buttons container */}
    </div>
  );
}

export default Header;
